export default __webpack_public_path__ + "static/media/radio-check.d9dc425f.svg";